export interface SubscriptionEventGq {
  message: string;
  eventTime: string;
  byUserEmail: string;
}

export const SubscriptionEventGqProps = `
  message
  eventTime
  byUserEmail
`;
